import { Schema, ParseResult } from "effect";
import { formDataToNestedObject, objectToFormData } from "./utils";

export const parseFormData = <A, I, R>(schema: Schema.Schema<A, I, R>) =>
  Schema.compose(
    Schema.transformOrFail(Schema.instanceOf(FormData), Schema.Any, {
      strict: true,
      decode: (i, _, ast) =>
        ParseResult.try({
          try: () => formDataToNestedObject(i),
          catch: (e) =>
            new ParseResult.Type(
              ast,
              i,
              e instanceof Error ? e.message : String(e),
            ),
        }),
      encode: (a, _, ast) =>
        ParseResult.try({
          try: () => objectToFormData(a),
          catch: (e) =>
            new ParseResult.Type(
              ast,
              a,
              e instanceof Error ? e.message : String(e),
            ),
        }),
    }),
    schema,
  );
